import { extractPersonCpf } from "src-next/modules/person-batch-register";
import { normalizeCpf } from "src-next/shared/utils/cpf";
import { getPatientCpf } from "../transformers/wooFormatters";
import type { Patient } from "fhir/r5";

/** Nome de exibição do cliente cadastrado (Person). */
export function getPersonDisplayName(person: fhir5.Person): string {
  const official = person.name?.find((name) => name.use === "official");
  const first = person.name?.[0];
  return (
    official?.text ||
    first?.text ||
    [...(first?.given || []), first?.family].filter(Boolean).join(" ") ||
    "Não informado"
  );
}

/** Telefone do cliente cadastrado. */
export function getPersonPhone(person: fhir5.Person): string {
  return (
    person.telecom?.find((telecom) => telecom.system === "phone")?.value ||
    person.telecom?.[0]?.value ||
    ""
  );
}

export function getPersonCpfDigits(person: fhir5.Person): string {
  return extractPersonCpf(person);
}

/** CPF só dígitos para cruzar paciente ↔ cliente. */
export function toEcommerceCpfKey(
  value: string | undefined | null,
): string {
  if (!value) return "";
  return normalizeCpf(value);
}

export function getPatientCpfKey(patient: Patient): string {
  return toEcommerceCpfKey(getPatientCpf(patient));
}
